import { type StateType } from '../../states';
import { type OverlayState } from '../../states/overlay';
import { type SpineAnimationId } from '../../types/animations';
import { type Selector } from '../../types/selectors';

const emptyObj = {};

export const selectOverlayState: Selector<OverlayState> = (state: StateType) => state.overlay ?? emptyObj;

export const selectOverlayAnimationId: Selector<SpineAnimationId | undefined> = (state: StateType) =>
  selectOverlayState(state)?.animationId;
